import { useCallback, useEffect, useState } from "react";

import { isOpenaiYamlFilePath } from "./openai-yaml-path";
import { OpenaiYamlPreviewMode } from "./openai-yaml-preview-mode";

export const useOpenaiYamlPreviewModeState = (selectedPath: string | null) => {
  const [openaiYamlPreviewMode, setOpenaiYamlPreviewMode] = useState(OpenaiYamlPreviewMode.Form);

  useEffect(() => {
    if (!selectedPath || !isOpenaiYamlFilePath(selectedPath)) {
      return;
    }
    setOpenaiYamlPreviewMode(OpenaiYamlPreviewMode.Form);
  }, [selectedPath]);

  const toggleOpenaiYamlPreviewMode = useCallback(() => {
    setOpenaiYamlPreviewMode(previous =>
      previous === OpenaiYamlPreviewMode.Form
        ? OpenaiYamlPreviewMode.Raw
        : OpenaiYamlPreviewMode.Form,
    );
  }, []);

  return {
    openaiYamlPreviewMode,
    setOpenaiYamlPreviewMode,
    toggleOpenaiYamlPreviewMode,
  };
};
